export const recurrenceUnits = [
    {
        id: 1,
        code: 'days',
        label: 'Days',
    },
    {
        id: 2,
        code: 'weeks',
        label: 'Weeks',
    },
    {
        id: 3,
        code: 'months',
        label: 'Months',
    },
];
